import { axios } from '@Root/API'

export const create = (student_course_sessions_description_id, payload) => {
	return axios.post('attache/post-grad/student-course-session', { ...payload, student_course_sessions_description_id })
}
